import { RecentNewsHighlight } from '@/components/dashboard/RecentNewsHighlight';
import { RecentSocialPostCard } from '@/components/dashboard/RecentSocialPostCard';
import { UpcomingEventsCard } from '@/components/dashboard/UpcomingEventsCard';
import { RecentConnectionsCard } from '@/components/dashboard/RecentConnectionsCard';

const Index = () => {
  return (
    <div className="p-8 space-y-8 relative min-h-screen">
      <div className="relative z-10 space-y-1">
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Your command center for cell and gene therapy market intelligence</p>
      </div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RecentNewsHighlight />
        <UpcomingEventsCard />
        <RecentSocialPostCard />
        <RecentConnectionsCard />
      </div>
    </div>
  );
};

export default Index;
